import ssoAjax from "../tools/sso.ajax";
import ssoAlert from "../tools/sso.alert";
import moment from "moment";

function buildMailSentModalConfig() {
    return {
        imageUrl: '/icon/modal/email.svg',
        imageAlt: language.register_mail_send,
        title: language.register_mail_send,
        html: `
            <p class="register-mail-sent-modal__description">
                ${language.one_more_step}<br>
                ${language.register_mail_verify}
            </p>
            <div class="register-mail-sent-modal__notice">
                <img src="/icon/modal/clock.svg" alt="" class="register-mail-sent-modal__notice-icon">
                <span>${language.register_mail_expire_notice}</span>
            </div>
        `,
        customClass: {
            popup: 'register-mail-sent-modal',
            image: 'register-mail-sent-modal__image',
            title: 'register-mail-sent-modal__title',
            htmlContainer: 'register-mail-sent-modal__content',
            footer: 'register-mail-sent-modal__footer',
        },
    };
}

export function init() {
    const emailVerificationForm = $('#email-verification-form');
    const btnSubmit = $('#btn_submit');
    const countdownSeconds = 60;

    function setCounter() {
        localStorage.setItem('counter_now', moment().toISOString());
    }

    function getCounter() {
        return localStorage.getItem('counter_now');
    }

    function clearCounter() {
        localStorage.removeItem('counter_now');
    }

    function lockSubmitButton() {
        btnSubmit.prop('disabled', true);
    }

    function releaseSubmitButton() {
        btnSubmit.prop('disabled', false).html(btnSubmit.data('text'));
    }

    function countdown() {
        lockSubmitButton();

        const counterTime = getCounter();

        if (!counterTime) {
            releaseSubmitButton();

            return;
        }

        const diffInSeconds = moment().diff(moment(counterTime), 'seconds');

        if (diffInSeconds > countdownSeconds) {
            releaseSubmitButton();
            clearCounter();

            return;
        }

        btnSubmit.html(`${(btnSubmit.data('text'))} (${countdownSeconds - diffInSeconds}s)`);

        setTimeout(countdown, 1000);
    }

    ssoAjax.checkToken();
    btnSubmit.data('text', btnSubmit.text());
    countdown();

    btnSubmit.on('click', function() {
        ssoAjax
            .withAuth()
            .submit(emailVerificationForm, function() {
                ssoAlert.fire(buildMailSentModalConfig());

                ssoAjax.btnSetToSubmit();
                setCounter();
                countdown();
            }, function(response) {
                if (response.status === 401) {
                    ssoAjax.redirectToLogin();

                    return false;
                }

                ssoAlert.error(language.verifying.resend_verification_mail_failed);
                ssoAjax.btnSetToSubmit();
            });

        return false;
    });
}
